// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"14163b1d","795":"f40c1010","941":"bca8014c"}[chunkId] + ".chunk.js";
};